import type { FaireProductEntity } from "../../entity_types/product";

export const p_nxktyasdm6: FaireProductEntity = {
  token: "p_nxktyasdm6",
  type: "product",
  name: "Espresso Thanks Boxed Card Set",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/105e7866d369d37c3772992ef8e599065023220b52427b6da539c98a3c10bf6d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1498545615611a89ceb19d72630a46beb5e6993c2c0978cece10d8fc2b96e932.jpeg",
    "https://cdn.faire.com/fastly/52d52f95e3d3f6e87002150179b74bdda043985bfb9a0270579db1d54d1d1404.jpeg",
  ],
  priceDollars: 11,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:00.319Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
